import React from 'react';

const PremiumProductIcon = () => (
  <img
    title="Premium"
    data-t="Premium icon"
    src={`${window.etp.config.assetsUrl}img/landing/products/himePremium.png`}
    srcSet={`${window.etp.config.assetsUrl}img/landing/products/himePremium@2x.png 2x`}
    alt="Premium Icon"
  />
);

export default PremiumProductIcon;
